import {
  collection,
  getFirestore,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { IoCloseCircleOutline } from 'react-icons/io5';
import Modal from '../components/Modal';
import background from '../images/test/n-profile.jpg';

const SportPage = () => {
  const [sport, setSport] = useState([]);
  const [list, setList] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [modalActive, setModalActive] = useState(false);

  useEffect(() => {
    const db = getFirestore();
    const q = query(collection(db, 'profiles'), where('group', '==', 'sport'));

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const data_list = [];
      querySnapshot.forEach((doc) => {
        data_list.push({ id: doc.id, data: doc.data() });
      });

      const qualified = data_list
        .filter((doc) => doc.data.stage)
        .map((doc) => {
          // let id = doc.id;
          // doc.data.stage = doc.data.stage.sort((a, b) => a - b);
          return { id: doc.id, data: doc.data, bestTime: doc.data.stage };
        })
        .sort((a, b) => a.bestTime - b.bestTime);

      setSport(qualified);

      const other = data_list.filter((doc) => !doc.data.stage);
      setList(other);
    });

    return () => {
      unsubscribe();
      console.log('Unsubscribed...');
    };
  }, []);

  const handleOpenModal = () => setModalActive(true);
  const handleCloseModal = () => {
    setModalActive(false);
    setCurrentUser(null);
  };

  const handleListItemClick = (event) => {
    const group = event.currentTarget.getAttribute('data-group');
    const id = event.currentTarget.id;

    if (group === 'sport') {
      setCurrentUser(getUserFromArr(sport, id));
    } else if (group === 'other') {
      setCurrentUser(getUserFromArr(list, id));
    }

    handleOpenModal();
  };

  function getUserFromArr(arr, id) {
    return arr.filter((doc) => doc.id === id)[0];
  }

  function getTimeFromNum(num) {
    const msInM = 60000;
    const msInS = 1000;
    let p1 = num % msInM;
    let p2 = (num % msInM) % msInS;

    let minutes = (num - p1) / msInM;
    let seconds = (p1 - p2) / msInS;
    let ms = p2;

    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    if (ms < 10) {
      ms = '00' + ms;
    } else if (ms < 100) {
      ms = '0' + ms;
    }

    return minutes + 'm ' + seconds + 's ' + ms + 'ms';
  }

  return (
    <>
      <div className="qual-top-bg">
        <div
          className="qual-top"
          style={{
            backgroundImage: `url(${
              sport.length > 0 && sport[0].data.photoUrl
                ? sport[0].data.photoUrl
                : background
            })`,
          }}
        >
          <div className="top-results">
            <div className="results-header">
              Лучший результат в группе SPORT
            </div>
            <div className="results-name">
              <div>
                <strong>
                  {sport.length > 0 && sport[0].data.firstName.toUpperCase()}
                </strong>
              </div>
              <span>
                {sport.length > 0 && sport[0].data.lastName.toUpperCase()}
              </span>
            </div>
            <div className="results-time">
              {sport.length > 0 && getTimeFromNum(sport[0].bestTime)}
            </div>
          </div>
        </div>
      </div>
      <div className="shadow"></div>

      <div className="list-of-profiles">
        {sport.length > 0 && (
          <div className="list-series">
            <div className="series sport"></div>
            <div className="list-items">
              {sport.map((item, index) => (
                <div
                  className="list-item sport"
                  key={item.id}
                  id={item.id}
                  data-group="sport"
                  onClick={handleListItemClick}
                >
                  <div>
                    {index < 3 ? <span>{index + 1 + '. '}</span> : ''}
                    {item.data.firstName} {item.data.lastName}
                  </div>
                  <div>{getTimeFromNum(item.bestTime)}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* <div className="list-series">
          <div className="series sport"></div>
          <div className="list-items">
            {list.map((item) => (
              <div
                className={item.data.staged ? "list-item sport" : "list-item other"}
                key={item.id}
                id={item.id}
                data-group="other"
                onClick={handleListItemClick}
              >
                <div>
                  {item.data.firstName} {item.data.lastName}
                </div>
                <div>{item.data.staged ? 'PASSED' : 'N/A'}</div>
              </div>
            ))}
          </div>
        </div> */}
      </div>

      <Modal active={modalActive} setActive={setModalActive}>
        <h2>
          {currentUser &&
            currentUser.data.firstName + ' ' + currentUser.data.lastName}
        </h2>
        <div className="modal-view">
          <div
            className="modal-pic"
            style={{
              backgroundImage: `url(${
                currentUser && currentUser.data.photoUrl
                  ? currentUser.data.photoUrl
                  : background
              })`,
            }}
          ></div>
          <div className="modal-text">
            <h4>CURRENT:</h4>
            <span>
              {currentUser && currentUser.bestTime
                ? getTimeFromNum(currentUser.bestTime)
                : 'N/A'}
            </span>
            <br />
            <h4>Qualification:</h4>
            {currentUser && currentUser.data.qual ? (
              <span>
                {getTimeFromNum(currentUser.data.qual.sort((a, b) => a - b)[0])}
              </span>
            ) : (
              <span>N/A</span>
            )}
          </div>
        </div>
        <button className="close-btn" onClick={handleCloseModal}>
          <IoCloseCircleOutline />
        </button>
      </Modal>
    </>
  );
};

export default SportPage;
